module.exports = __webpack_public_path__ + "img/test1.72c948e7.png";